import { useEffect, ReactElement } from 'react';
import { useRouter } from 'next/router';

import { FeatureFlags } from 'featureFlags/constants';
import { useFeatureFlag } from 'shared/hooks';
import { useAuthState } from 'auth/hooks/useAuth';
import { fireImpactPageView } from 'tracking/utils/impactEvents';

declare global {
  interface Window {
    ire: any;
  }
}

interface IImpactProviderProps {
  children: ReactElement;
}

export const ImpactProvider = ({ children }: IImpactProviderProps) => {
  const router = useRouter();
  const isImpactEnabled = useFeatureFlag(FeatureFlags.WEB_ENABLE_IMPACT);
  const { user } = useAuthState();

  useEffect(() => {
    void fireImpactPageView({ id: user?.id, email: user?.email });
  }, []);

  useEffect(() => {
    if (!isImpactEnabled) return null;

    router.events.on('routeChangeComplete', () =>
      fireImpactPageView({ id: user?.id, email: user?.email }),
    );

    return () => {
      router.events.off('routeChangeComplete', () =>
        fireImpactPageView({ id: user?.id, email: user?.email }),
      );
    };
  }, [router.events]);

  return children;
};
